import { combineReducers } from 'redux';
import rootCommon, { IManageCommon } from './Common';


export interface IAppState {
  common: IManageCommon;
}
export const rootReducer = () => combineReducers<IAppState>({
  common: rootCommon
});

export type AppState = IAppState;
export default rootReducer;
